exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-pairing__title{line-height:normal}.app-pairing__to-get-started{line-height:1.5}.app-pairing__bitmap{width:356px;width:22.25rem;height:138px;height:8.625rem;display:block;margin-left:auto;margin-right:auto}@media only screen and (max-width:400px){.app-pairing__bitmap{width:100%;height:100%}}.app-pairing__header{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;padding:3em 0}.app-pairing__header--spread{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-732e898e","scoped":false,"hasInlineConfig":false}!./~/postcss-loader!./~/sass-loader/lib/loader.js!./app/components/app-pairing/style.scss
// module id = 251
// module chunks = 0